import api from '@/services/utils/apiInstance.ts';
import type { AploAsset } from '@/types/services/aplo/aplo.type.ts';

class AploService {
  async getAssets(): Promise<AploAsset[]> {
    const response = await api.get(`/aplo/assets`)
    return response.data
  }
}

export default new AploService();
